import { Tooltip } from 'react-tooltip';
import { useMemo } from 'react';

import { ReactComponent as InfoIcon } from '@/assets/icons/info.svg';

import styles from './component.module.scss';

export const InfoTooltip = ({ content }: { content: React.ReactNode }) => {
  const tooltipId = useMemo(() => Math.floor(Math.random() * 10000), []);

  return (
    <span
      className={styles.main}
      data-tooltip-id={`dor-explorer-info-${tooltipId}`}
    >
      <InfoIcon />
      <Tooltip
        id={`dor-explorer-info-${tooltipId}`}
        clickable
        className={styles.tooltip}
        classNameArrow={styles.tooltipArrow}
      >
        {content}
      </Tooltip>
    </span>
  );
};
